import { ExtractPropTypes, PropType } from 'vue'
import { PickerMultiSelectorProps } from '@tarojs/components'

export const multiSelectorPickerProps = {

  /* 表单项值 */
  modelValue: {
    type: Array as PropType<(string | number)[]>,
    default: [],
  },

  options: {
    type: Array as PropType<Reference.ReferenceItem[][]>,
    default: () => [],
    required: true,
  },

  /* 是否禁用 */
  disabled: {
    type: Boolean,
    default: false,
  },

  /* 占位符 */
  placeholder: {
    type: String,
    default: ''
  },

  /* 文字对齐 */
  textAlign: {
    type: String as PropType<'left' | 'right'>,
    default: 'left',
  }
}

export type MultiSelectorPickerProps = Partial<ExtractPropTypes<typeof multiSelectorPickerProps>> & PickerMultiSelectorProps